import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateAndUpdateProjectAssignments = async (
  projectId,
  assignmentsToCreate,
  assignmentsToUpdate
) => {
  const apiPath = `projects/${projectId}/assignments/create-and-update-assignments`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { assignmentsToCreate, assignmentsToUpdate },
  });

  const response = await axios(signedRequest);

  return response.data;
};
